<template>
  <div class="ticketInfoBg pr">
    <div>
      <div class="ticketInfo">
        <table width="100%" cellspacing="0">
          <tr>
            <td rowspan="2" class="tl"><span class="dl w5 h14 bge1241a br4 mr10"></span>票面信息</td>
            <td>票号</td>
            <td style="min-width: 64px">承兑人</td>
            <td style="min-width: 94px">到期日</td>
            <td>票面金额</td>
            <td v-if="code == 3||code == 4||code == 5" class="bgF1F5F8">融资可得</td>
            <td rowspan="2" v-if="code === 1" class="w150">
              <Button type="info" class="" ghost @click="reUpload">重新上传</Button>
            </td>
            <td rowspan="2" v-if="code == 3||code == 4||code == 5" class="w150">
              <Button type="info" class="detailBtn" ghost @click="detail = !detail">查看详情</Button>
            </td>
          </tr>
          <tr>

            <td>
              <div class="dCC">
                <p>
                  <Tooltip :content="allParam.billNo" placement="bottom" max-width="300" class="tool-tip-s">
                    <span class="">...{{allParam.billNo.substring(allParam.billNo.length-9,allParam.billNo.length)}}</span>
                  </Tooltip>
                </p>
              </div>
            </td>
            <td>
              <div class="dCC">
                <p>{{allParam.acceptorName}}</p>
              </div>
            </td>
            <td>
              <div class="dCC">
                <p>{{allParam.dueDate}} <span class="brdB50000 cB50000" v-if="allParam.dueDays">{{allParam.dueDays}}</span> </p>
              </div>
            </td>
            <td>
              <div class="dCC">
                <p>{{formatMoney(allParam.billAmount, 2, '')}} <span class="brd333333">{{digitUppercase(allParam.billAmount)}}</span></p>
              </div>
            </td>
            <td v-if="code == 3||code == 4||code == 5">
              <div class="dCC ">
                <p><span class="cB50000 fb">{{formatMoney(allParam.discountAmount, 2, '')}}</span> 年化<span class="cB50000 fb">{{Number(allParam.discountRate).mul(100).toFixed(2)}}%</span></p>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="ticketInfo-detail " v-if="detail">
        <div class=" fSpace  w100b fm bdr10">
          <div>
            <table class="bccc c333">
              <tr>
                <td rowspan="3" class="bre9e9e9 w80 h40  tc c333">订单信息</td>
                <td class="bre9e9e9 w130 h40 bbe9e9e9 tc c666 bgF1F5F8">订单编号</td>
                <td class="bbe9e9e9 w360 tl pl20">{{allParam.orderNo}}</td>
              </tr>
              <tr>
                <td class="bre9e9e9 w130 h40 tc c666 bgF1F5F8 bbe9e9e9">报价机构</td>
                <td class="w40 tl pl20 bbe9e9e9">{{allParam.creditChannel.channelDesc}}</td>
              </tr>
              <tr>
                <td class="bre9e9e9 w130 h40 tc c666 bgF1F5F8 ">订单类型</td>
                <td class="w360 tl pl20 ">{{ parentsData.getCodeType(allParam.discountType)}}</td>
              </tr>
            </table>
            <table class="bccc mt20 c333">
              <tr>
                <td rowspan="4" class="bre9e9e9 w80 h40  tc c333">融资人信息</td>
                <td class="bre9e9e9 w130 h40 bbe9e9e9 tc c666 bgF1F5F8">名称</td>
                <td class="bbe9e9e9 w360 tl pl20">{{allParam.acct.corpName}}</td>
              </tr>
              <tr>
                <td class="bre9e9e9 w130 h40 tc c666 bgF1F5F8 bbe9e9e9">回款账号</td>
                <td class="w40 tl pl20 bbe9e9e9">{{allParam.acct.acctNo}}</td>
              </tr>
              <tr>
                <td class="bre9e9e9 w130 h40 tc c666 bgF1F5F8 bbe9e9e9">开户行</td>
                <td class="w360 tl pl20 bbe9e9e9">{{allParam.acct.branchBankName}}</td>
              </tr>
              <tr>
                <td class="bre9e9e9 w130 h40 tc c666 bgF1F5F8 ">开户行号</td>
                <td class="w360 tl pl20 ">{{allParam.acct.branchBankNo}}</td>
              </tr>
            </table>
          </div>
          <div class="bccc  pl16 pr16 pt10 w47b left ">
            <div class="top  w100b">
              <p class="f16 c333 tl bbccc ">融票价</p>
              <div class="mt10 ">
                <div class="fSpace h70 cB50000 ">
                  <div class="cFFD7D5 w48b fSpace aic  br4">
                    <div class="bdr50b w40 h40 bgfff dCC ml14 f12">年化</div>
                    <p class="mr16 f16  fb">{{Number(allParam.discountRate).mul(100).toFixed(2)}}%</p>
                  </div>
                  <div class="cFFD7D5 w48b fSpace aic br4">
                    <div class="bdr50b w40 h40 bgfff dCC ml14 f12">每十万</div>
                    <p class="mr16 f16 fb">{{formatMoney(allParam.discountMsw, 2, '')}}</p>
                  </div>
                </div>
              </div>

            </div>
            <div class="bottom mt20 c666">
              <p class="tl">可收款明细：</p>
              <div class="bgFAFAFA p14 br4">
                <p class="fSpace"><span>票面金额</span> <span class="fb c333">{{formatMoney(allParam.billAmount, 2, '')}}元</span> </p>
                <p class="fSpace bbccc pb8"><span>总付息</span> <span class="fb c333">- {{formatMoney(allParam.discountInterest, 2, '')}}元</span> </p>
                <p class="fSpace pt8"><span>融票可得</span> <span class="cB50000 fb">= {{formatMoney(allParam.discountAmount, 2, '')}}元</span> </p>
              </div>
            </div>
          </div>
        </div>
        <div class="pt20 mt14">
          <Button type="primary" class="w150" @click="detail = false">关闭</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['allParam', 'code'],
  inject: ['parentsData'],
  data () {
    return {
      detail: false
    }
  },
  created () {
    console.log('allParam', this.allParam, this.parentsData, this.$parent);
  },
  methods: {
    reUpload () {
      console.log('allParam', this.allParam, this.parentsData, this.$parent);
      this.$parent.reUpload()
    }
  }
}
</script>

<style scoped lang="scss" type="text/css" >
.cFFD7D5 {
  background: #ffd7d5;
}
.brdB50000 {
  border: 1px solid #b50000;
  padding: 0 2px;
  border-radius: 4px;
}
.brd333333 {
  border: 1px solid #333333;
  padding: 0 2px;
  border-radius: 4px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.cB50000 {
  color: #b50000;
}
.bgF1F5F8 {
  background: #f1f5f8;
}
.ivu-btn-info {
  color: #333 !important;
  background-color: #fafafa;
  border-color: #e9e9e9;
}
.ivu-btn-info:hover {
  color: #0077da !important;
  background-color: #fafafa;
  border-color: #0077da;
}

.ticketInfoBg {
  /*height: 230px;*/
  padding: 14px;
  // background: rgba(104, 177, 232, 0.53)
  //   url(~@/assets/img/businessTicketDiscount/wen@2x.png) no-repeat bottom left;
  // background-size: 100%;
  font-size: 14px;
  // background: #fff;

  > p {
    color: #2b5879;
    line-height: 14px;
    margin-bottom: 9px;
  }
  .ticketInfo {
    table {
      border: 1px solid #cccccc;
      font-size: 12px;
      td {
        border-left: 1px solid #e9e9e9;
        height: 28px;
        padding: 0 10px;
        &:nth-child(1) {
          width: 74px;
        }

        div {
          p {
            line-height: 16px;
          }
        }
      }
      tr {
        &:nth-child(2) td {
          border-top: 1px solid #cccccc;
          color: #333;
        }
        &:nth-child(1) td {
          color: #666;
          &:nth-child(1) {
            color: #333;
            padding-left: 0;
            margin: 0;
          }
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5) {
            background: #f1f5f8;
            border-left: 1px solid #e9e9e9;
          }
        }
      }
    }
  }
  .ticketInfo-detail {
    width: 98%;
    height: 400px;
    padding: 10px 16px;
    position: absolute;
    top: 72px;
    left: 50%;
    transform: translateX(-50%);
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);
    border-radius: 6px 6px 6px 6px;
    z-index: 99;
    &::before {
      width: 0;
      height: 0;
      content: '';
      border: 6px solid #ffffff;
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom: 12px solid #f2f2f2;
      position: absolute;
      top: -18px;
      right: 80px;
      // box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);
    }
  }
  > div {
    width: 100%;
    /*height: 150px;*/
    // background-color: #f6f7f8;
    // padding: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/businessTicketDiscount/ticketInfo.vue